import { render, staticRenderFns } from "./DeliveryOption.vue?vue&type=template&id=f4d77c1a&scoped=true&"
import script from "./DeliveryOption.vue?vue&type=script&lang=js&"
export * from "./DeliveryOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4d77c1a",
  null
  
)

export default component.exports